import { Icons } from '@/components/icons';
import { Typography } from '@/components/primitives/Typography';
import { TransText } from '@/i18n/trans/text';
import type {
  ProfileBookingTimeType,
  ProfileBookingType,
} from '@/types/profile';
import type { FC } from 'react';

interface BookingNoItemsProps {
  bookingType: ProfileBookingType;
  timeType: ProfileBookingTimeType;
}

const BookingNoItems: FC<BookingNoItemsProps> = ({ bookingType, timeType }) => {
  const Icon = bookingType === 'tickets' ? Icons.ticket : Icons.travelPass;

  return (
    <div className="flex w-full flex-col items-center gap-6 py-8 laptop:max-w-[628px]">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-warning-surface">
        <Icon className="h-10 w-10 text-dark" />
      </div>
      <Typography>
        <TransText i18nKey={getTextKey(bookingType, timeType)} />
      </Typography>
    </div>
  );
};

export default BookingNoItems;

const getTextKey = (
  bookingType: ProfileBookingType,
  timeType: ProfileBookingTimeType
) => {
  if (bookingType === 'tickets') {
    return timeType === 'active' ? 'noUpcomingTickets' : 'noHistoryTickets';
  }

  return timeType === 'active'
    ? 'noActiveTravelPasses'
    : 'noHistoryTravelPasses';
};
